export const medalGroupsTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [{
    label: '分组名称',
    prop: 'name',
    overHidden: true,
  }, {
    label: '是否在用户端显示',
    prop: 'isActive',
    overHidden: true,
    solt: true,
  }, {
    label: '排序',
    prop: 'sort',
    overHidden: true,
    sortable: true,
  }, {
    label: '创建人',
    prop: 'creatorName',
    overHidden: true,
    solt: true,
  }, {
    label: '创建时间',
    prop: 'insertedTime',
    overHidden: true,
    sortable: true,
  }]
}